import React from 'react'

function Images() {
  return (
    <div>
      Images
    </div>
  )
}

export default Images
